import axios from 'axios';
import _, { map, omitBy, isEmpty, isNil, omit, toUpper } from 'lodash';

import { errorHandler } from '../utils';

export const getVoucherList = async(filters) => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/ecom/voucher/list`;
    
    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: filters
        });

        return response.data.vouchers
        // return normalize.model.profile(response.data.profile);
    }
    catch (err: any) {
        const { error } = err.response?.data || {};

        if (!isEmpty(error)) {
            const callback = async () => await getVoucherList(filters);
            const { value, code, message, stack } = await errorHandler.response(error, { callback });
            return { error: { value, code, message, stack }};
        }
        else {
            return { error: { message: err.message }};
        }
    }
}

export const fetchCheckoutVoucherList = async(filters) => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/ecom/voucher/checkout`;
    
    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: filters
        });

        return response.data;
    }
    catch (err: any) {
        const { error } = err.response?.data || {};

        if (!isEmpty(error)) {
            const callback = async () => await fetchCheckoutVoucherList(filters);
            const { value, code, message, stack } = await errorHandler.response(error, { callback });
            return { error: { value, code, message, stack }};
        }
        else {
            return { error: { message: err.message }};
        }
    }
}

export const verifyVoucherList = async(filters) => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/ecom/voucher/verify`;
    
    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: filters
        });
        return typeof response.data.data.discountedAmount === "number" ? response.data.data.discountedAmount : parseFloat(response.data.data.discountedAmount);
    }
    catch (err: any) {
        const { error } = err.response?.data || {};

        if (!isEmpty(error)) {
            const callback = async () => await verifyVoucherList(filters);
            const { value, code, message, stack } = await errorHandler.response(error, { callback });
            return { error: { value, code, message, stack }};
        }
        else {
            return { error: { message: err.message }};
        }
    }
}